import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PaperCard } from 'components/Card/PaperCard';
import { ContentLayout } from 'website/components/Layout/components/ContentLayout';
import { LocalizedLink } from 'website/components/LocalizedLink';
import { unsubscribeByToken } from 'website/api/unsubscribe';
import { ROOT_PATHS } from 'routes';

export const UnsubscribePage = () => {
  const { t } = useTranslation();
  const { token, listName } = useParams();
  const [status, setStatus] = useState('initial'); // 'initial', 'loading', 'success', 'error'

  const handleUnsubscribe = async () => {
    setStatus('loading');
    try {
      await unsubscribeByToken(token);      
      setStatus('success');
    } catch (error) {
      console.log(error);
      
      console.error("Unsubscribe failed:", error);
      setStatus('error');
    }
  };

  const renderContent = () => {
    switch (status) {
      case 'loading':
        return <CircularProgress />;
      case 'success':
        return (
          <Stack gap={2} alignItems="center">
            <Typography variant="h4" fontWeight="bold">{t('website:unsubscribe.successHeading')}</Typography>
            <Typography variant="body1" fontWeight={500}>
              {t('website:unsubscribe.successTextBefore')}{' '}
              <span style={{ fontWeight: 'bold' }}>
                {listName}
              </span>
              {' '}{t('website:unsubscribe.successTextAfter')}
            </Typography>
            <Button component={LocalizedLink} to={ROOT_PATHS.WEBSITE} variant="contained">
              {t('website:unsubscribe.backToHomepage')}
            </Button>
          </Stack>
        );
      case 'error':
        return (
          <Stack gap={2} alignItems="center">
            <Typography variant="h4" color="error" fontWeight="bold">{t('website:unsubscribe.errorHeading')}</Typography>
            <Typography variant="body1" fontWeight={500}>{t('website:unsubscribe.errorDescription')}</Typography>
            <Stack direction="row" justifyContent="center" gap={1}>
              <Button component={LocalizedLink} to={ROOT_PATHS.WEBSITE} variant="contained">
                {t('website:unsubscribe.backToHomepage')}
              </Button>
            </Stack>
          </Stack>
        );
      case 'initial':
      default:
        return (
          <Stack gap={2} alignItems="center">
            <Typography variant="h4" fontWeight="bold">{t('website:unsubscribe.heading')}</Typography>
            <Typography variant="body1" fontWeight={500}>
              {t('website:unsubscribe.confirmTextBefore')}{' '}
              <span style={{ fontWeight: 'bold' }}>
                {listName}
              </span>
              {' '}{t('website:unsubscribe.confirmTextAfter')}
            </Typography>

            <Stack direction="row" justifyContent="center" gap={1}>
              <Button variant="contained" color="primary" component={LocalizedLink} to={ROOT_PATHS.WEBSITE}>
                {t('website:unsubscribe.cancelButton')}
              </Button>
              <Button variant="outlined" onClick={handleUnsubscribe}>
                {t('website:unsubscribe.confirmButton')}
              </Button>
            </Stack>
          </Stack>
        );
    }
  };

  return (
    <ContentLayout title={t('website:unsubscribe.pageTitle')}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          py: 10,
          minHeight: '50vh',
          alignSelf: 'center',
          px: 5,
        }}
      >
        <PaperCard>
          {renderContent()}
        </PaperCard>
      </Box>
    </ContentLayout>
  );
};
